<template>
    <div class="w-100">
        <div class="">
            <div class="col-lg-12">
                <!-- <h5 class="font-weight-bold pb-4 text-center">Pool Invite</h5> -->
                <div class="card rounded-0 shadow-sm border-0 w-100" style="height:100vh;">
                    <div class="card-body">

                        <div class="d-flex flex-column text-center my-auto justify-content-center align-items-center h-100">
                            <h5 class="font-weight-bold">Thank you for using MoneyPool by Vesicash</h5>
                            <p class="">
                                
                                <router-link tag="button" class="btn btn-link" to="/login">Create a pool today</router-link>
                            </p>

                        </div>

                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>